import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
    FaBars, FaTimes, FaUserCircle, FaSignOutAlt, FaUser,
    FaAngleDown, FaTachometerAlt, FaPhone
} from "react-icons/fa";

import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { useAuth } from "../context/AuthContext";
import { calculateProfileCompletion } from "../utils/profileHelpers";
import { jeePremiumSeries, neetPremiumSeries, jeeUltimateCombo, neetUltimatePremium } from "../data/testSeriesData";
import "./Navbar.css";
import logo from "./image/PrrepX Logo.jpg";

const navItems = [
    { path: "/test-series", label: "Test Series" },
    { path: "/exam-guide", label: "Exam Guide" },
    { path: "/test-series/pyq", label: "Free Mock Tests" },
/*
    {
        type: "dropdown", label: "PYQ Tests (Free)", items: [
            { path: "/test-series/pyq", label: "PYQ Test Series HUB" },
            { path: "/test-series/pyq/neet", label: "NEET PYQ Test(Free)" },
            { path: "/test-series/pyq/jeemains", label: "JEE Mains PYQ Test(Free)" },
            { path: "/test-series/pyq/jeeadv", label: "JEE Adv PYQ Test(Free)" },
        ]
    },
    
    {
        type: "dropdown", 
        label: "JEE Premium Test Page", 
        items: [
        
            { path: "/test-series/jee-premium", label: "JEE Premium Test Page" },
            ...jeePremiumSeries.map(series => ({
                path: `/test-series/jee-premium/${series.id}`,
                label: series.title
            })),
         // Combo pack first, highlighted
            {
                path: jeeUltimateCombo[0].link,
                label: (
                  <span style={{color:'#ff9800',fontWeight:800,display:'flex',alignItems:'center'}}>
                    <span role="img" aria-label="combo">💎</span> {jeeUltimateCombo[0].title}
                    <span style={{background:'linear-gradient(90deg,#ff9800 60%,#ffd54f 100%)',color:'#fff',borderRadius:12,padding:'2px 10px',marginLeft:8,fontSize:'0.9em'}}>🔥 Combo</span>
                  </span>
                )
            },
        ]
    },
    {
        type: "dropdown", 
        label: "NEET Premium Test Page", 
        items: [
            
            { path: "/test-series/neet-premium", label: "NEET Premium Test Page" },
            ...neetPremiumSeries.map(series => ({
                path: `/test-series/neet-premium/${series.id}`,
                label: series.title
            })),
            {
                path: neetUltimatePremium[0].link,
                label: (
                  <span style={{color:'#ff9800',fontWeight:800,display:'flex',alignItems:'center'}}>
                    <span role="img" aria-label="combo">💎</span> {neetUltimatePremium[0].title}
                    <span style={{background:'linear-gradient(90deg,#ff9800 60%,#ffd54f 100%)',color:'#fff',borderRadius:12,padding:'2px 10px',marginLeft:8,fontSize:'0.9em'}}>🔥 Combo</span>
                  </span>
                )
            },
        ]
    },*/
    { path: "/test-series/jee-premium", label: "JEE Premium Tests" },
    { path: "/test-series/neet-premium", label: "NEET Premium Tests" },
    
    { path: "https://www.prrepxpathshala.live/doubt-portal24*7", label: "Doubt Portal 24×7" },
];

const CallNowButton = ({ isMobile: isMob, handleLinkClick }) => (
    <a href="tel:+918287648766" className={isMob ? 'mobile-call-now-btn' : 'call-now-btn'} onClick={handleLinkClick}>
        {!isMob ? (
            <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', alignItems: 'center', minWidth: 90 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                    <FaPhone className="call-icon" />
                    <span className="call-text">Call Now</span>
                </div>
                <span className="call-number" style={{ fontWeight: 600, fontSize: '0.90rem', marginLeft: 0 }}>+918287648766</span>
            </div>
        ) : (
            <>
                <FaPhone className="call-icon" />
                <div className="call-info">
                    <span className="call-text">Call Now</span>
                    <span className="call-number">+918287648766</span>
                </div>
            </>
        )}
    </a>
);

const HomePortalButton = ({ isMobile, onClick }) => (
    <Link
        to="https://prrepxpathshala.live/"
        target="_blank"
        rel="noopener noreferrer"
        className={isMobile ? "mobile-employee-portal-btn" : "employee-portal-btn"}
        onClick={onClick}
    >
        Home Portal
    </Link>
);

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    const [openDropdown, setOpenDropdown] = useState(null); // Only one open at a time
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const [profileCompletion, setProfileCompletion] = useState({ percentage: 100, isComplete: true });

    const { currentUser: user, isAdmin, userData } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const navRefs = useRef([]);
    const [sliderStyle, setSliderStyle] = useState({});

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1024);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const isDesktop = window.innerWidth > 1024;
        if (!isDesktop) {
            setSliderStyle({ width: 0, left: 0 });
            return;
        }

        let index = -1;
        let visibleIndex = 0;

        navItems.forEach(item => {
            if (!item.type && item.path === location.pathname) {
                index = visibleIndex;
            }
            if (!item.type) visibleIndex++;
        });

        if (index !== -1 && navRefs.current[index]) {
            const el = navRefs.current[index];
            setSliderStyle({
                left: el.offsetLeft,
                width: el.offsetWidth
            });
        } else {
            setSliderStyle({ width: 0, left: 0 });
        }
    }, [location.pathname]);

    const toggleDropdown = (label) => {
        setOpenDropdown(prev => (prev === label ? null : label));
        setUserDropdownOpen(false);
    };

    const toggleUserDropdown = () => {
        setUserDropdownOpen(prev => !prev);
        setOpenDropdown(null);
    };

    const closeAll = () => {
        setMenuOpen(false);
        setOpenDropdown(null);
        setUserDropdownOpen(false);
    };

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClick = (e) => {
            // Only close if click is outside navbar
            if (!e.target.closest('.new-navbar')) {
                closeAll();
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    // Calculate profile completion
    useEffect(() => {
        if (userData) {
            const completion = calculateProfileCompletion(userData);
            setProfileCompletion(completion);
        } else {
            setProfileCompletion({ percentage: 100, isComplete: true });
        }
    }, [userData]);

    const logout = async () => {
        await signOut(auth);
        closeAll();
        navigate("/");
    };

    const AuthBtns = ({ isMobile }) => (
        <>
            {!user ? (
                <Link to="/login"
                    className={`login-btn ${isMobile ? "mobile-btn" : ""}`}
                    onClick={closeAll}
                >
                    Login
                </Link>
            ) : (
                <li className={`user-dropdown-wrapper ${isMobile ? "mobile-user-li" : ""}`} 
                    style={isMobile ? {} : { display: 'flex', alignItems: 'center', height: 'var(--action-btn-height)', position: 'relative' }}>
                    
                    <button
                        className={`user-info-box ${isMobile ? "mobile-user-toggle" : "desktop-user-toggle"}`}
                        onClick={toggleUserDropdown}
                    >
                        <FaUserCircle className="user-icon" />
                        {!isMobile ? (
                            <div className="user-name-stack">
                                <span className="user-name-display">
                                    {user.displayName?.split(" ")[0] || user.email?.split("@")[0] || user.phoneNumber?.slice(-4) || "User"}
                                </span>
                                {!profileCompletion.isComplete && (
                                    <span className="profile-incomplete-chip">Profile Incomplete &middot; {100 - profileCompletion.percentage}%</span>
                                )}
                            </div>
                        ) : (
                            <span className="user-name-display">
                                {user.displayName?.split(" ")[0] || user.email?.split("@")[0] || user.phoneNumber?.slice(-4) || "User"}
                            </span>
                        )}
                        <FaAngleDown className={`dropdown-arrow ${userDropdownOpen ? "open" : ""}`} />
                        {!profileCompletion.isComplete && isMobile && (
                            <span className="profile-incomplete-badge" title={`Profile ${100 - profileCompletion.percentage}% incomplete`}>
                                {100 - profileCompletion.percentage}%
                            </span>
                        )}
                    </button>

                    <ul className={`user-dropdown-menu ${isMobile ? "mobile-user-dropdown" : "desktop-user-dropdown"} ${userDropdownOpen ? "open" : ""}`}>
                        <li className="user-details-header">
                            <div className="user-avatar">
                                {user.photoURL ? (
                                    <img src={user.photoURL} alt="Profile" className="user-avatar-img" />
                                ) : (
                                    <FaUserCircle className="user-avatar-icon" />
                                )}
                            </div>
                            <div className="user-info">
                                <div className="user-display-name">{user.displayName || "User"}</div>
                                <div className="user-email">{user.email || user.phoneNumber || ""}</div>
                            </div>
                        </li>
                        <li className="menu-divider"></li>
                        <li>
                            <Link to="/purchased-tests" onClick={closeAll}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                </svg>
                                <span>My Purchased Tests</span>
                            </Link>
                        </li>



                        {/* Admin Panel button: only if user has any admin access (role or dashboardAccess) */}
                        {userData && (
                            (
                                userData.role === 'superadmin' ||
                                (
                                    userData.role === 'admin' && (
                                        userData.dashboardAccess?.dashboard ||
                                        userData.dashboardAccess?.userManagement ||
                                        userData.dashboardAccess?.salesInvoices
                                    )
                                ) ||
                                (
                                    userData.role !== 'superadmin' && userData.role !== 'admin' && (
                                        userData.dashboardAccess?.dashboard ||
                                        userData.dashboardAccess?.userManagement ||
                                        userData.dashboardAccess?.salesInvoices
                                    )
                                )
                            ) && (
                                <li className="admin-link-li">
                                    <Link to="/admin" onClick={closeAll}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="3" y="3" width="7" height="7"/>
                                            <rect x="14" y="3" width="7" height="7"/>
                                            <rect x="14" y="14" width="7" height="7"/>
                                            <rect x="3" y="14" width="7" height="7"/>
                                        </svg>
                                        <span>Admin Panel</span>
                                    </Link>
                                </li>
                            )
                        )}



                        <li>
                            <Link to="/profile" onClick={closeAll} className="user-menu-item">
                                <FaUser />
                                <span className={!profileCompletion.isComplete ? "view-profile-text-animated" : undefined}>View Profile</span>
                                {!profileCompletion.isComplete && (
                                    <span className="view-profile-incomplete-tag">(Incomplete &middot; {100 - profileCompletion.percentage}%)</span>
                                )}
                            </Link>
                        </li>

                        <li className="menu-divider"></li>
                        <li className="logout-item" onClick={logout}>
                            <FaSignOutAlt />
                            <span>Logout</span>
                        </li>
                    </ul>
                </li>
            )}

            {isMobile ? (
                <>
                    <li className="mobile-contact-li">
                        <Link
                            to="/inquiry-now"
                            className="mobile-contact-link"
                            onClick={closeAll}
                        >
                            Inquiry Now
                        </Link>
                    </li>
                    <li className="mobile-homeportal-li">
                        <HomePortalButton isMobile={isMobile} onClick={closeAll} />
                    </li>
                </>
            ) : (
                <>
                    <Link
                        to="/inquiry-now"
                        className="contact-btn"
                        onClick={closeAll}
                    >
                        Inquiry Now
                    </Link>
                    <HomePortalButton isMobile={isMobile} onClick={closeAll} />
                </>
            )}
        </>
    );

    return (
        <nav className="new-navbar">
            <div className="navbar-container">
                <div className="top-bar">
                    <Link to="/" className="logo-box" onClick={closeAll}>
                        <img src={logo} className="logo-img" alt="PrepX Pathshala Logo" />
                        <div className="site-title">
                            <h1><span className="site-name">PrrepX</span> <span className="site-name-2">Test Portal</span></h1>
                            <span className="tagline">India's Best Test Series for JEE Mains, JEE Advance and NEET</span>
                        </div>
                    </Link>

                    <div className="right-actions">
                        <div className="desktop-actions">
                            <CallNowButton isMobile={false} handleLinkClick={closeAll} />
                            <AuthBtns isMobile={false} />
                        </div>

                        <div className="mobile-trigger-container">
                            <div>
                                {user && !profileCompletion.isComplete && isMobile && (
                                    <span className="mobile-menu-notification-badge">{100 - profileCompletion.percentage}%</span>
                                )}
                                <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                                    {menuOpen ? <FaTimes /> : <FaBars />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bottom-bar">
                    <ul className="nav-links-main">
                        <li key="/test-series">
                            <Link to="/test-series" onClick={closeAll} className={location.pathname === "/test-series" ? "active" : ""}>
                                Test Series
                            </Link>
                        </li>
                        
                        {navItems.filter(item => item.path !== "/test-series").map((item, idx) => {
                            if (item.type === "dropdown") {
                                return (
                                    <li key={item.label} className="dropdown">
                                        <span className="dropdown-toggle"
                                            onClick={() => toggleDropdown(item.label)}
                                        >
                                            {item.label}
                                            <FaAngleDown className={openDropdown === item.label ? "open" : ""} />
                                        </span>

                                        <ul className={`dropdown-menu ${openDropdown === item.label ? "active" : ""}`}>
                                            {item.items.map(sub => {
                                                return (
                                                    <li key={sub.path}>
                                                        <Link to={sub.path} onClick={closeAll}>
                                                            {sub.label}
                                                        </Link>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </li>
                                );
                            }
                            
                            const refIndex = navRefs.current.filter(Boolean).length;

                            return (
                                <li key={item.path}
                                    ref={(el) => (navRefs.current[refIndex] = el)}
                                >
                                    <Link
                                        to={item.path}
                                        onClick={closeAll}
                                        className={location.pathname === item.path ? "active" : ""}
                                        target={item.path.startsWith('http') ? "_blank" : undefined}
                                        rel={item.path.startsWith('http') ? "noopener noreferrer" : undefined}
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            );
                        })}
                        
                    </ul>
                    
                </div>
            </div>

            {isMobile && menuOpen && (
                <div className="mobile-dropdown-overlay" onClick={(e) => { if (e.target === e.currentTarget) setMenuOpen(false); }}>
                    <div className="mobile-dropdown-panel">
                        <div className="mobile-dropdown-header">
                            <Link to="/" className="logo-box" onClick={closeAll}>
                                <img src={logo} alt="PrepX Pathshala" className="logo-img" />
                                <span className="site-name">PrrepX Test Portal</span>
                            </Link>
                            <button className="mobile-dropdown-close" onClick={() => setMenuOpen(false)}><FaTimes /></button>
                        </div>
                        <div className="mobile-dropdown-content">
                            <ul className="mobile-dropdown-list">
                                <li><CallNowButton isMobile={true} handleLinkClick={closeAll} /></li>
                                {!user && (
                                    <li><Link to="/login" className="login-btn mobile-btn mobile-login-top" onClick={closeAll}>Login</Link></li>
                                )}
                                {user && (
                                    <li className="mobile-user-li mobile-user-top">
                                        <button className="mobile-user-toggle" onClick={toggleUserDropdown}>
                                            <div className="toggle-left">
                                                <FaUserCircle className="user-icon" />
                                                <div className="toggle-name-stack">
                                                    <span>{user.displayName?.split(" ")[0] || user.email?.split("@")[0]}</span>
                                                    {!profileCompletion.isComplete && (
                                                        <span className="mobile-incomplete-chip">Profile Incomplete &middot; {100 - profileCompletion.percentage}%</span>
                                                    )}
                                                </div>
                                            </div>
                                            <FaAngleDown className={userDropdownOpen ? "open" : ""} />
                                        </button>
                                        <ul className={`mobile-user-dropdown-list${userDropdownOpen ? " open" : ""}`}>
                                            <li className="user-details-header">
                                                <div className="user-avatar">
                                                    {user.photoURL ? <img src={user.photoURL} alt="Profile" className="user-avatar-img" /> : <FaUserCircle className="user-avatar-icon" />}
                                                </div>
                                                <div className="user-info">
                                                    <div className="user-display-name">{user.displayName || "User"}</div>
                                                    <div className="user-email">{user.email || ""}</div>
                                                </div>
                                            </li>
                                            <li className="menu-divider"></li>
                                            <li>
                                                <Link to="/purchased-tests" onClick={closeAll} className="user-menu-item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                                                    <span>My Purchased Tests</span>
                                                </Link>
                                            </li>
                                            {userData && (
                                                (userData.role === 'superadmin' || (userData.role === 'admin' && (userData.dashboardAccess?.dashboard || userData.dashboardAccess?.userManagement || userData.dashboardAccess?.salesInvoices)) || (userData.role !== 'superadmin' && userData.role !== 'admin' && (userData.dashboardAccess?.dashboard || userData.dashboardAccess?.userManagement || userData.dashboardAccess?.salesInvoices))) && (
                                                    <li>
                                                        <Link to="/admin" onClick={closeAll} className="user-menu-item">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                                                            <span>Admin Panel</span>
                                                        </Link>
                                                    </li>
                                                )
                                            )}
                                            <li>
                                                <Link to="/profile" onClick={closeAll} className="user-menu-item">
                                                    <FaUser />
                                                    <span className={!profileCompletion.isComplete ? "view-profile-text-animated" : undefined}>View Profile</span>
                                                    {!profileCompletion.isComplete && (
                                                        <span className="view-profile-incomplete-tag">(Incomplete &middot; {100 - profileCompletion.percentage}%)</span>
                                                    )}
                                                </Link>
                                            </li>
                                            <li className="menu-divider"></li>
                                            <li><span className="logout-item" onClick={logout}><FaSignOutAlt /> Logout</span></li>
                                        </ul>
                                    </li>
                                )}
                                {navItems.map(item => (
                                    item.type === "dropdown" ? (
                                        <li key={item.label} className="mobile-dropdown">
                                            <details>
                                                <summary className="mobile-dropdown-toggle">{item.label} <FaAngleDown /></summary>
                                                <ul className="mobile-dropdown-menu">
                                                    {item.items.map(sub => (<li key={sub.path}><Link to={sub.path} onClick={closeAll}>{sub.label}</Link></li>))}
                                                </ul>
                                            </details>
                                        </li>
                                    ) : (
                                        <li key={item.path}>
                                            <Link to={item.path} onClick={closeAll}
                                                target={item.path.startsWith('http') ? "_blank" : undefined}
                                                rel={item.path.startsWith('http') ? "noopener noreferrer" : undefined}
                                            >{item.label}</Link>
                                        </li>
                                    )
                                ))}
                                <li className="mobile-action-buttons">
                                    <Link to="/inquiry-now" className="mobile-btn" onClick={closeAll}>Inquiry Now</Link>
                                    <HomePortalButton isMobile={true} onClick={closeAll} />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
}